import Accordion, {
  AccordionGroup,
} from '@components/elements/accordion/accordion';
import Image from '@components/elements/image/image';
import { v2_useCmsBlock } from '@crocodille/common';
import { isSome } from '@crocodille/util';
import pizzaBackground from './background.svg';

import styles from './pizza-manifesto.module.scss';

const PizzaManifesto: React.FC = () => {
  const { data: block1 } = v2_useCmsBlock('manifesto_1');
  const { data: block2 } = v2_useCmsBlock('manifesto_2');
  const { data: block3 } = v2_useCmsBlock('manifesto_3');
  const { data: block4 } = v2_useCmsBlock('manifesto_4');
  const { data: block5 } = v2_useCmsBlock('manifesto_5');
  const { data: block6 } = v2_useCmsBlock('manifesto_6');

  const blocks = [block1, block2, block3, block4, block5, block6].filter(
    isSome,
  );

  return (
    <div className={styles.container}>
      <div className={styles.manifesto}>
        <AccordionGroup>
          {blocks.map((block, index) => (
            <Accordion
              key={block.code}
              title={block.name}
              initialOpen={index === 0}
            >
              <p className={styles.blockContent}>{block.content}</p>
            </Accordion>
          ))}
        </AccordionGroup>
      </div>
      <Image
        src={pizzaBackground}
        className={styles.pizza}
        alt=""
        role="presentation"
      />
    </div>
  );
};

export default PizzaManifesto;
